/** Rounds to 2 decimals without the usual floating point drift. */
export const round2 = (value) =>
  Math.round((Number(value) + Number.EPSILON) * 100) / 100;

/** "12.50" — the amount only, for use next to a currency label. */
export const formatAmount = (value) => round2(value || 0).toFixed(2);

/**
 * "12.50 TND" — a full price, as shown on tiles, totals and receipts.
 *
 * Wrapped in a bidi isolate so it keeps that order inside Arabic text, where
 * it would otherwise be laid out as "TND 12.50".
 */
export const formatMoney = (value, currency = "TND") =>
  `\u2066${formatAmount(value)} ${currency}\u2069`;

/**
 * Cash denominations worth offering as one-tap buttons: every note that is
 * larger than the total, plus the next round figure above it.
 */
export const quickCashOptions = (total, notes = [5, 10, 20, 50, 100, 200]) => {
  const roundedUp = Math.ceil(total / 5) * 5;
  const options = notes.filter((note) => note >= total);

  if (roundedUp >= total && !options.includes(roundedUp)) {
    options.push(roundedUp);
  }

  return [...new Set(options)].sort((a, b) => a - b).slice(0, 4);
};
